


const sendFeedbackForm = (dataFromFeedback, accordionFeedbackSuccess, accordionFeedbackFail, accordionFeedbackTextarea, accordionFeedbackSendForm) => {
    $.ajax({
        type: 'POST',
        url: '/api/mailfeedback/mailto/',
        contentType: 'application/json;charset=utf-8',
        data: JSON.stringify(dataFromFeedback),
        dataType: 'json'
    })
    .done(() => {
        accordionFeedbackTextarea.attr("disabled", true);
        accordionFeedbackSendForm.attr("disabled", true);
        accordionFeedbackFail.hide();
        accordionFeedbackSuccess.show();
        console.log("success");
    })
    .fail(() => {
        accordionFeedbackFail.show();
        console.log("fail");
    });
}

const events = () => {
    const $accordionFaqListItem = $('.accordion__item');

    window.addEventListener('hashchange', () => {
        if (!window.location.hash) {
            return;
        }
        const accordionItem = document.querySelector(`.accordion__item${window.location.hash}`);
        if (accordionItem !== null) {
            accordionItem.open = true;
        }
    });

    for ( var i = 0; i < $accordionFaqListItem.length; i++ ) {
        let accordionFaq = $($accordionFaqListItem[i]).parents(".js-accordion-faq")
        let accordionFaqEmail = accordionFaq.find(".js-accordion-faq-email");
        let accordionFaqHeading = accordionFaq.find(".js-accordion-faq-heading");
        let accordionFaqItemQuestion = $($accordionFaqListItem[i]).find('.accordion__title');
        let accordionFaqItemButtons = $($accordionFaqListItem[i]).find('.accordion__feedback__buttons .button');
        let accordionFaqItemButtonNO = $($accordionFaqListItem[i]).find('.accordion__feedback__buttons .js-accordion-feedback-no');
        let accordionFaqItemButtonYes = $($accordionFaqListItem[i]).find('.accordion__feedback__buttons .js-accordion-feedback-yes');
        let accordionFeedbackContainer = $($accordionFaqListItem[i]).find('.accordion__feedback__form');
        let accordionFeedbackContentTexts = $($accordionFaqListItem[i]).find('.accordion__feedback__content p');
        let accordionFeedbackSendForm = $($accordionFaqListItem[i]).find('.js-feedback-send');
        let accordionFeedbackFormSuccess = $($accordionFaqListItem[i]).find('.accordion__feedback__form__success');
        let accordionFeedbackFormFail = $($accordionFaqListItem[i]).find('.accordion__feedback__form__fail');
        let accordionFeedbackTextarea = $($accordionFaqListItem[i]).find('.textarea');

        if (accordionFaqItemButtonNO) {
            accordionFaqItemButtonNO.on('click', () => {
                accordionFaqItemButtons.attr("disabled", true);
                accordionFeedbackContainer.slideToggle();
            });
        }

        if (accordionFaqItemButtonYes) {
            accordionFaqItemButtonYes.on('click', () => {
                accordionFaqItemButtons.attr("disabled", true);
                accordionFeedbackContentTexts.toggle();
            });
        }

        if (accordionFeedbackSendForm) {
            accordionFeedbackSendForm.on('click', () => {
                const feedbackData = {
                    pageHeading: accordionFaqHeading.val(),
                    question: accordionFaqItemQuestion.text(),
                    clientFeedback: accordionFeedbackTextarea.val(),
                    mail: accordionFaqEmail.val()
                }
                sendFeedbackForm(feedbackData, accordionFeedbackFormSuccess, accordionFeedbackFormFail, accordionFeedbackTextarea, accordionFeedbackSendForm);

            });
        }
    }
}

const init = () => {
    events();
}

export default init;